import type { LevelDefinition } from '../world/LevelDefinition';

const surfaces = {
  floor: { enabled: true, magnetic: true },
  ceiling: { enabled: true, magnetic: true },
  left: { enabled: true, magnetic: true },
  right: { enabled: true, magnetic: true },
  front: { enabled: true, magnetic: true },
  back: { enabled: true, magnetic: true },
};

const ceilingLights = (zs: number[]) =>
  zs.map((z) => ({
    position: [0, 3.9, z] as [number, number, number],
    size: [2.2, 0.08, 1.1] as [number, number, number],
  }));

/**
 * Outer Hull: a spine corridor with two side bays. The outer faces are
 * exterior hull, marked with viewports that look out onto space. Firing the AR
 * at any hull face opens the hull and fails the mission, so the net gun and the
 * magnetic grapple are the safe tools here.
 */
export const OUTER_HULL: LevelDefinition = {
  id: 'outer-hull',
  name: 'Outer Hull',
  size: [32, 4, 36],
  surfaces,
  zones: [
    {
      id: 'spine',
      origin: [0, 0, 0],
      size: [8, 4, 36],
      hullFaces: ['left', 'right', 'front', 'back'],
    },
    {
      id: 'port',
      origin: [-8, 0, 0],
      size: [8, 4, 16],
      hullFaces: ['left', 'front', 'back'],
    },
    {
      id: 'starboard',
      origin: [8, 0, 0],
      size: [8, 4, 16],
      hullFaces: ['right', 'front', 'back'],
    },
  ],
  portals: [
    {
      id: 'spine-port',
      a: 'spine',
      b: 'port',
      axis: 'z',
      position: [-4, 0, 0],
      width: 3.2,
      height: 3,
    },
    {
      id: 'spine-starboard',
      a: 'spine',
      b: 'starboard',
      axis: 'z',
      position: [4, 0, 0],
      width: 3.2,
      height: 3,
    },
  ],
  spawn: { zone: 'spine', surface: 'floor', position: [0, 0, 14], facing: Math.PI },
  targets: [
    { type: 'drone', zone: 'spine', surface: 'floor', position: [0, 0, -12], magnetic: true },
    { type: 'drone', zone: 'port', surface: 'floor', position: [-9, 0, 0] },
    { type: 'drone', zone: 'starboard', surface: 'floor', position: [9, 0, 0], magnetic: true },
    { type: 'drone', zone: 'spine', surface: 'ceiling', position: [0, 4, 6] },
  ],
  obstacles: [
    {
      type: 'box',
      kind: 'console',
      zone: 'spine',
      position: [2.6, 0.5, 4],
      size: [2.2, 1, 0.8],
    },
    {
      type: 'box',
      kind: 'console',
      zone: 'spine',
      position: [-2.6, 0.5, -6],
      size: [2.2, 1, 0.8],
    },
    {
      type: 'box',
      kind: 'crate',
      zone: 'port',
      position: [-9.5, 0.6, 5],
      size: [1.2, 1.2, 1.2],
    },
    {
      type: 'box',
      kind: 'crate',
      zone: 'starboard',
      position: [9.5, 0.6, -5],
      size: [1.2, 1.2, 1.2],
    },
  ],
  style: {
    wallColor: 0x2a3038,
    floorColor: 0x1b2026,
    ceilingColor: 0xc9d6e2,
    pathColor: 0xffb347,
    path: [
      { from: [0, 16], to: [0, -16], width: 2.4 },
      { from: [0, 0], to: [-8, 0], width: 2 },
      { from: [0, 0], to: [8, 0], width: 2 },
    ],
    ceilingLights: ceilingLights([14, 8, 2, -4, -10, -16]),
  },
  seed: 7331,
};
